<template>
  <div class="ShaneBlaser">
    <nav-bar></nav-bar>
    <br><br>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4"><img class="circular--landscape" src="../assets/shaneSquare.png" style="width:250px"></div>
      <div class="col-md-4"></div>

    </div>
      <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <br>
              <li>
        <a
          href="mailto:shaneblaser@gmail.com" target="_top">
          <h5><strong>eMail</strong></h5>
        </a>
      </li>
      </div>
      <div class="col-md-4"></div>
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar'
import SessionData from '../components/SessionData'
export default {
  name: 'ShaneBlaserMessage',
  data () {
    return {
      msg: "Shane Blaser's home page"
    }
  },
  components: {
    NavBar,
    SessionData
  },
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/ShaneBlaser.vue